module.exports = __webpack_public_path__ + "img/background-map.392128d5.png";